export default "__VITE_ASSET__BtFF0II$__"